import React, { useState, useEffect } from "react";
import { Header } from "../../../components/Header/Header";
import "./style.css";
import axios from 'axios';
import AOS from 'aos';
import { getAnalytics, logEvent } from "firebase/analytics";
import { Link } from 'react-router-dom';
import { BookCoverVorlage } from "../../../bookchoice/components/BookCoverVorlage"; 
import { Header_New } from "../../../components/Header_new"; 

const Landingpage = () => {
  const [books, setBooks] = useState([]); // State to store the books data
  const [data, setData] = useState({});
  useEffect(() => {
    const scrollableContainer = document.querySelector('.scrollableContainer');
  
    const handleScroll = (e) => {
      // Check if the scrollable container can actually scroll further
      const isAtStart = scrollableContainer.scrollLeft === 0;
      const isAtEnd = scrollableContainer.scrollLeft === scrollableContainer.scrollWidth - scrollableContainer.clientWidth;
  
      // If not at the start or the end, or if scrolling up when at the start, or if scrolling down when at the end,
      // prevent the default scroll action (which is vertical scrolling).
      if (!isAtStart && !isAtEnd || (isAtStart && e.deltaY > 0) || (isAtEnd && e.deltaY < 0)) {
        e.preventDefault();
        scrollableContainer.scrollLeft += e.deltaY;
      }
    };
  
    scrollableContainer.addEventListener('wheel', handleScroll, {passive: false}); // Notice the passive option set to false
  
    return () => {
      if (scrollableContainer) {
        scrollableContainer.removeEventListener('wheel', handleScroll);
      }
    };
  }, []);
  useEffect(() => {
    // Fetch data from the backend
    const fetchData = async () => {
      try {
        const response = await axios.get('https://picked-chigger-top.ngrok-free.app/get_stats/',{
          headers: {
          'ngrok-skip-browser-warning': 'true'
        }});
        setData(response.data);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const analytics = getAnalytics();
    logEvent(analytics, 'landingpage');
    // Fetch books data from the backend
    const fetchBooks = async () => {
      try {
        const response = await axios.get('https://picked-chigger-top.ngrok-free.app/get_best_books/',{ 
        headers: {
          'ngrok-skip-browser-warning': 'true'
        }
        });
        setBooks(response.data); // Set the books data to state
      } catch (error) {
        console.error('There was an error fetching the books data:', error);
      }
    };

    fetchBooks();
  }, []);
  useEffect(() => {
    var canvas = document.getElementById('matrixCanvas'),
        ctx = canvas.getContext('2d');
  
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
  
    var letters = 'ABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZABCDEFGHIJKLMNOPQRSTUVXYZ';
    letters = letters.split('');
  
    var fontSize = 10,
        columns = canvas.width / fontSize;
  
    var drops = [];
    for (var i = 0; i < columns; i++) {
      drops[i] = 1;
    }
  
    function draw() {
      ctx.fillStyle = 'rgba(255, 102, 0, .1)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
  
      for (var i = 0; i < drops.length; i++) {
        var text = letters[Math.floor(Math.random() * letters.length)];
        ctx.fillStyle = '#ffffff';
        ctx.fillText(text, i * fontSize, drops[i] * fontSize);
        drops[i]++;
        if (drops[i] * fontSize > canvas.height && Math.random() > .99) {
          drops[i] = 0;
        }
      }
    }
  
    setInterval(draw, 33);
  
    // Clean up the interval on component unmount
    return () => clearInterval(draw);
  }, []);
  useEffect(() => {
    const adjustCanvasSize = () => {
      const firstScreen = document.querySelector('.firstScreen');
      const canvas = document.querySelector('.matrixCanvas');
      if (firstScreen && canvas) {
        canvas.style.height = `${firstScreen.offsetHeight}px`;
        canvas.width = firstScreen.offsetWidth;
        canvas.height = firstScreen.offsetHeight;
      }
    };

    // Adjust the canvas size on mount
    adjustCanvasSize();

    // Add event listener to adjust the canvas size on window resize
    window.addEventListener('resize', adjustCanvasSize);

    // Cleanup function to remove the event listener
    return () => window.removeEventListener('resize', adjustCanvasSize);
  }, []);
  return (
    <div className="landingpage">
      {/*Header<Header></Header>*/}
      <Header_New></Header_New>
      <div className="firstScreen">
      <canvas className="matrixCanvas" id="matrixCanvas"></canvas>
        <div className="main-text">
          <h1>Heute schon gelesen?</h1>
        </div>
        <div className="scroll-indicator">
          <span className="scroll-text">Beginne deine Reise!</span>
          <div className="arrow-circle"><img src="https://firebasestorage.googleapis.com/v0/b/weread-45736.appspot.com/o/arrow.png?alt=media&token=87a6a03e-5c45-4452-b211-47eba859c683"></img></div> {/* This is a simple down arrow; you might want to use an icon */}
        </div>
      </div>
      <div className="secondScreen">
        <div className="books-header">Unsere Empfehlungen</div>
        <div className="books">
            {books.map(book => (
            <BookCoverVorlage buch={book} />
          ))}
        </div>
      </div>
      <div className="thirdScreen">
      <h1 className="stats-header">Interessante Statistiken</h1>
        <div className="scrollableContainer">
          {Object.entries(data).map(([key, value]) => (
            <div className="dataBox" key={key}>
              <h2>{key}</h2>
              <p>{value}</p>
            </div>
          ))}
      </div>
      </div>
    </div>
  );
};

export default Landingpage;